import ImpactivoCircleWhiteSvg from '@centria-ui/assets/images/impactivo/impactivo-icon-white.svg'
import ImpactivoTextWhiteSvg from '@centria-ui/assets/images/impactivo/impactivo-text-white.svg'
import ImpactivoCircleSvg from '@centria-ui/assets/images/impactivo/impactivo-icon.svg'
import ImpactivoWhiteSvg from '@centria-ui/assets/images/impactivo/impactivo-white.svg'
import ImpactivoSvg from '@centria-ui/assets/images/impactivo/impactivo.svg'

export const ImpactivoIcon = () => <ImpactivoSvg />
export const ImpactivoWhiteIcon = () => <ImpactivoWhiteSvg />
export const ImpactivoCircleIcon = () => <ImpactivoCircleSvg />
export const ImpactivoTextWhiteIcon = () => <ImpactivoTextWhiteSvg />
export const ImpactivoCircleWhiteIcon = () => <ImpactivoCircleWhiteSvg />
